import PropTypes from 'prop-types';

export const ITEMS_PROP_TYPE = PropTypes.arrayOf(
    PropTypes.shape({
        value: PropTypes.number.isRequired,
        displayName: PropTypes.node.isRequired,
        content: PropTypes.element,
        isSelected: PropTypes.bool,
    }),
);
